import { Box, Divider } from "@mui/material";
import { styled } from "@mui/material/styles";

export const OrderDishesWrapper = styled(Box)(({ theme }) => ({
	display: "flex",
	flexDirection: "column",
	width: "100%",
	gap: theme.spacing(1),
	overflow: "auto",
}));

export const OrderItemBlockWrapper = styled(OrderDishesWrapper)(() => ({}));

export const OrderDishDivider = styled(Divider)(() => ({
	borderColor: "rgba(255, 255, 255, 0.5)",
	margin: "8px 0",
}));

export const DrawerWrapper = styled(Box)(() => ({
	width: "100%",
	height: "100%",
	display: "flex",
	flexDirection: "column",
	justifyContent: "flex-start",
	alignItems: "center",
}));
